// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__GP2gX","popup":"Notification_popup__2KL3B","error":"Notification_error__1KxdJ","success":"Notification_success__2R5G0"};